// extracted by mini-css-extract-plugin
module.exports = {"Img":"Fit_Img__3tR8r"};